import React from 'react'
import SVG from 'react-inlinesvg'
import './TagTransparentBanner.scss'

function TagTransparentBanner({ typeColor, icon, title, subtitle }) {
  return (
    <div className={`tag-transparent-banner type-${typeColor}`}>
      <div className="card-center-icon">
        {icon && (
          <SVG className="counter-info-icon" src={icon} preProcessor={(code) => code.replace(/filter=".*?"/g, '')} />
        )}
      </div>
      <p className="card-center-title">{title}</p>
      <p className="card-center-text max-line-3 mt-2">{subtitle}</p>
    </div>
  )
}

export default TagTransparentBanner
